import { render, staticRenderFns } from "./pop_evwriting_view.vue?vue&type=template&id=450801a2&scoped=true&"
import script from "./pop_evwriting_view.vue?vue&type=script&lang=js&"
export * from "./pop_evwriting_view.vue?vue&type=script&lang=js&"
import style0 from "./pop_evwriting_view.vue?vue&type=style&index=0&id=450801a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450801a2",
  null
  
)

export default component.exports